import React from 'react';
import { string } from 'prop-types';
import { PublicNavWrapper } from './PublicNav.styles';
import { SmallViewportMenu } from './SmallViewportMenu';
import { LargeViewportMenu } from './LargeViewportMenu';
import { useWidth } from '../..';
export const PublicNav = _ref => {
  let {
    pathname,
    loginUrl,
    registerUrl,
    pageTitle
  } = _ref;
  const width = useWidth();
  const isSmall = width === 'sm' || width === 'xs';
  return /*#__PURE__*/React.createElement(PublicNavWrapper, null, isSmall ? /*#__PURE__*/React.createElement(SmallViewportMenu, {
    "data-test-id": "small-menu",
    loginUrl: loginUrl,
    registerUrl: registerUrl
  }) : /*#__PURE__*/React.createElement(LargeViewportMenu, {
    "data-test-id": "large-menu",
    pathname: pathname,
    loginUrl: loginUrl,
    registerUrl: registerUrl,
    pageTitle: pageTitle
  }));
};
PublicNav.propTypes = {
  pathname: string.isRequired,
  loginUrl: string,
  registerUrl: string,
  pageTitle: string
};
PublicNav.defaultProps = {
  loginUrl: '',
  registerUrl: '',
  pageTitle: ''
};